import {
  DirectSalesDealLineAllocationFailureResponse,
  DirectSalesDealLineFailureMessage,
} from 'components/common/types/DirectSalesCampaign.types';
import { ToastProps } from 'lib/Toaster/Toaster.types';

const LINE_NAME_MAX_LENGTH = 40;

export type FailedDealLine = {
  id?: string;
  name: string;
  allocationFailures?: DirectSalesDealLineAllocationFailureResponse[];
};

const truncateLineName = (lineName: string): string => {
  return lineName.length > LINE_NAME_MAX_LENGTH ? `${lineName.substring(0, LINE_NAME_MAX_LENGTH)}...` : lineName;
};

export const transformFailedLinesToConfirmToasts = (failedLines: FailedDealLine[]): ToastProps[] => {
  return failedLines.map(({ id, name }) => ({
    id: id ?? name,
    header: `Allocation failed`,
    description: `Cannot confirm campaign because ${truncateLineName(name)} does not have a valid solution`,
    type: 'Failure',
    timeout: 10000,
  }));
};

export const transformLinesAllocationFailuresToToasts = (dealLinesResponse: FailedDealLine[]): ToastProps[] => {
  return dealLinesResponse.reduce<ToastProps[]>(
    (acc, { id, name, allocationFailures = [] }) =>
      id
        ? [
            ...acc,
            ...allocationFailures.map<ToastProps>(({ failureCode }) => ({
              id,
              header: `${truncateLineName(name)} allocation failed`,
              description: DirectSalesDealLineFailureMessage[failureCode] ?? 'Please reallocate your campaign.',
              type: 'Failure',
            })),
          ]
        : acc,
    [],
  );
};
